import React, { Suspense } from "react";
import { OrbitControls, Preload, useGLTF } from "@react-three/drei";

import CanvasLoader from "../Loader";
import SafeCanvas from "./SafeCanvas"; // <-- ajusta ruta si no cuadra

const Earth = () => {
  const earth = useGLTF("./planet/scene.gltf");
  return <primitive object={earth.scene} scale={1.5} position-y={0} rotation-y={0} />;
};

const Fallback = () => (
  <div className="w-full h-full min-h-[320px] rounded-xl bg-black/20 flex items-center justify-center">
    <p className="text-white/70 text-sm">Visual 3D no disponible en Firefox (WebGL).</p>
  </div>
);

const EarthCanvas = () => {
  return (
    <SafeCanvas
      fallback={<Fallback />}
      shadows
      frameloop="demand"
      camera={{ fov: 45, near: 0.1, far: 200, position: [-4, 3, 6] }}
    >
      <Suspense fallback={<CanvasLoader />}>
        <OrbitControls
          autoRotate
          enableZoom={false}
          maxPolarAngle={Math.PI / 2}
          minPolarAngle={Math.PI / 2}
        />
        <Earth />
        <Preload all />
      </Suspense>
    </SafeCanvas>
  );
};

export default EarthCanvas;